import axios from "axios"
import accessToken from "./jwt-token-access/accessToken"

//pass new generated access token here
//apply base url for axios
const API_URL = "https://6e3oue93qi.execute-api.us-east-1.amazonaws.com/default"
const RESOURCES_URL = "http://sagetest.growmyownfood.com:5000/api"
const STRIPE_URL = "http://sagetest.growmyownfood.com:5000"
const FREEBIE_URL = "https://s16ixz1n3g.execute-api.us-east-1.amazonaws.com/freebie"

const axiosApi = axios.create({
  baseURL: API_URL,
})
axios.defaults.headers.post['Content-Type'] ='application/json';

const resourcesApi = axios.create({
  baseURL: RESOURCES_URL,
})

const stripeApi = axios.create({
  baseURL: STRIPE_URL
})

const freebieApi = axios.create({
  baseURL: FREEBIE_URL,
})

axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
)

export async function getResources(config = {}) {
  return await resourcesApi.get("/resources", { ...config })
    .then(response => {
	 return response.data
    })
}

export async function getFreebieData(url, data, config = {}) {
	console.log("HGHGHGH")
  return freebieApi.get(url, { ...config })
    .then(response => response.data)
}

export async function postStripeInfo(url, data, config = {}) {
  console.log(url)
  return stripeApi.post(url, { customer: data }, { ...config })
    .then(response => {
	    console.log("SUCCESS")
	    return response.data
    })
}

export async function getStripeInfo(url, data, config = {}) {
  console.log(url)
  return stripeApi.get(url, { ...config })
    .then(response => response.data)
}


export async function get(url, config = {}) {
  console.log (url + ":::::" + config)
  return await axiosApi.get(url, { ...config })
     .then(response => {
	     console.log(response);
	     return response.data
     })
}

export async function post(url, data, config = {}) {
  console.log(url + "::::" + data);
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function put(url, data, config = {}) {
  console.log(url + "::::" + config)
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url, config = {}) {
  console.log(url);
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}
